"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotTrendingDown = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotTrendingDown = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    fillRule: "evenodd",
    d: "M21.05 11.6c2.345.53 6.56.676 9.275 3.336 2.715 2.668 4.665 7.349 3.14 10.032-1.535 2.677-6.602 2.358-11.015 3.432-4.422 1.081-8.238 2.565-10.905 1.365-2.66-1.2-4.1-4.086-4.895-7.425-.802-3.34-.889-6.134-.11-8.47.771-2.336 2.424-4.207 4.304-4.823 1.889-.608 3.28-.084 4.956.453 1.367.584 2.898 1.563 5.25 2.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M38.335 30 22.5 14.167 14.168 22.5 1.668 10m36.667 20H28.334m10 0V20"
  }));
};
exports.SpotTrendingDown = SpotTrendingDown;
SpotTrendingDown.displayName = "SpotTrendingDown";